import React from "react";
import Banner from "./Banner/Banner";
import Cards from "./Cards/Cards";
import Timer from "./Timer/Timer";
import Brands from "./Brands/Brands";
import Card2 from "./Card2/Card2";
import Speciality from "./Speciality/Speciality";
export default function Home(){
return(
<>
<Banner/>
<Cards/>
<Speciality/>
<Brands/>
<Timer/>
<Card2/>
</>
)
}